import React, { useState } from "react";
import { Button, Modal } from "@telia/teddy";
import { useDispatch } from "react-redux";
import { cancelAndRestart } from "../../../state/actions";
import PAGES from "../../../../../../constants/pages";
import "./CancelOrderModal.less";

interface CancelOrderModalProps {
    onClose: () => void;
}

const CancelOrderModal: React.FC<CancelOrderModalProps> = ({ onClose }) => {
    const dispatch = useDispatch();
    const [isCancelling, setIsCancelling] = useState(false);

    return (
        <Modal open onOpenChange={onClose}>
            <Modal.Overlay className="cancel-order-modal__container">
                <Modal.Content>
                    <Modal.Group variant="title">
                        <Modal.Title as="h3">Slett nåværende og start nytt salg?</Modal.Title>
                    </Modal.Group>
                    Hele bestillingen vil bli slettet og du vil gå tilbake til start.
                    <Modal.Group variant="action">
                        <Modal.Close slot="content">
                            <Button variant="secondary" onClick={onClose} disabled={isCancelling}>
                                Bli værende
                            </Button>
                        </Modal.Close>
                        <Button
                            variant="destructive"
                            onClick={async () => {
                                if (isCancelling) return;
                                setIsCancelling(true);
                                try {
                                    await dispatch(cancelAndRestart());
                                    window.location.assign(PAGES.RETAILER.NEWORDER.URL);
                                } catch (e) {
                                    // oxlint-disable-next-line no-console
                                    console.error("[CancelOrderModal] Failed to cancel and restart order", e);
                                } finally {
                                    setIsCancelling(false);
                                }
                            }}
                            loading={isCancelling}
                        >
                            Slett ordre
                        </Button>
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default CancelOrderModal;
